import { FieldConditions } from 'modules/settings/pods/settings-automation-rules/constants/frontend-enums';
import { AutomationRulesInput } from '../automation-rules-input';
import { BaseProps } from '../field-conditional.type';

export interface InputFieldProps extends BaseProps {
    fieldCondition?: FieldConditions.input;
    name: string;
    placeholder?: string;
    defaultValue?: string;
    type?: string;
}

export const InputField: React.FC<InputFieldProps> = (props) => {
    const { name, placeholder, defaultValue, onChange, type } = props || {};

    return (
        <AutomationRulesInput
            name={name}
            placeholder={placeholder}
            defaultValue={defaultValue}
            type={type ?? ''}
            onChange={onChange}
        />
    );
};
